import axios from 'axios';
import API_BASE_URL from '../config.js';

const getCities = async (event) => {

    const response = await axios.get(`${API_BASE_URL}/cities/`,
    );

    return response.data;

};

export default getCities;
